export default __webpack_public_path__ + "static/media/youtubeDesk.aca88b79.svg";